import { Injectable } from '@angular/core';
import { BackendModule } from '../modules/backend.module';
import { SessionService } from './session';
import { AuthService } from './auth';

@Injectable()
export class ReservationsService {

    constructor(public sessionService:SessionService,
        public backendModule: BackendModule,
        public authService:AuthService) {}

    bookClass(gymId, lessonId, scheduleId, extras = false){
        return new Promise((resolve, reject) => {
        this.backendModule.postAPI(`gyms/${gymId}/lessons/${lessonId}/schedules/${scheduleId}/reservations?user_id=${this.sessionService.user.id}${extras?'&extras=true':''}`, {})
            .subscribe(
                (response: any) => {
                    let userId = this.sessionService.user.id;
                    this.authService.getUserInfo(userId);
                    this.authService.trackEvent('reservation', 'book', userId);
                    resolve(response);
                },
                (error)=>{reject(error)}
                )
        })
   }

    cancelClass(gymId, lessonId, scheduleId, reservationId){
        return new Promise((resolve, reject) => {
            this.backendModule.deleteAPI(`gyms/${gymId}/lessons/${lessonId}/schedules/${scheduleId}/reservations/${reservationId}`)
            .subscribe((response: any) => { 
                let userId = this.sessionService.user.id;
                this.authService.getUserInfo(userId);
                this.authService.trackEvent('reservation', 'cancel', userId);
                resolve(response);
            },
                (error) => { 
                    reject(error) 
            }) 
        })
   }
}



// WEBPACK FOOTER //
// ./src/services/reservations.ts